// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__k2N88","loading":"styles_loading__cYaxY","ready":"styles_ready__PU4S5"};